<p>
  Estás en:
  <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
    <a *ngIf="!last" href="" class="breadcrumb-item breadLink">
      {{ breadcrumb.label }}
    </a>

    <span *ngIf="last" class="breadcrumb-item active">
      {{ breadcrumb.label }}
    </span>
    <span *ngIf="!last" class="material-symbols-outlined chevron_right">
      chevron_right
    </span>
  </ng-container>
</p>
